import {usePreventDragging} from '../preventDragging.js';
import {dist} from './utils.js';
import {WIDTH, HEIGHT, PADDING} from './constants.js';
import {getParametersFromSelection} from './selection.js';
import {useRef, useEffect, useCallback, useState} from 'react';
const MIN_DRAG = 2;
const DOUBLE_CLICK_TIME = 380;

let c=0;

var timestamp = null;
var lastMouseX = null;
var lastMouseY = null;

export const useMouse = ({
    ref,
    effect,
    setEffectParameterValues,
    filteredParameters,
    isRegionMode,
    isDensitiesMode,
    setDensities,
    setSelectedDensity,
    macroToShow
}) => {
    let lastClick = useRef(0);
    let [drawMode, setDrawMode] = useState(true);
    let sequencerEngine = effect.track.sequencerEngine;
    let [selection, setSelection] = useState(undefined);
    let [dragging, setDragging] = useState(undefined);
    let [selected, setSelected] = useState([]);

    const getXY = useCallback((e) => {
        let rect = ref.current.getBoundingClientRect();
        return {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        };
    }, [ref]);

    const onMouseDown = useCallback((e) => {
        e.stopPropagation();
        if (!sequencerEngine.playing) {
            return;
        }
        let {x,y} = getXY(e);
        if (drawMode) {
            effect.setPencil(x,y);
        } else {
            setSelection({x1:x, y1:y, x2:x, y2:y});
        }
    }, [setSelection, setSelected, drawMode]);

    const isCommandDown = () => {
        return sequencerEngine.state.keyboard.isCommandDown;
    };
    
    const onMouseUp = useCallback((e) => {
        if (drawMode) {
            effect.setPencil(null, null);
            return;
        }
        // given the selection get the selected parameters

        if (selection) {
            if(selection.x1 !== selection.x2 && selection.y1 !== selection.y2) {
                if (isDensitiesMode) {
                    let radius = dist(selection);
                    if (!isNaN(selection.x1) && !isNaN(selection.y1)) {
                        let density = effect.newRegion(selection.x1, selection.y1, radius);
                        setDensities(effect.regions);
                        setSelectedDensity(density);
                    }
                }
                if (isRegionMode) {
                    let {x1, x2, y1, y2} = selection;
                    for (let p of selected) {
                        let min = p.originalMin + (p.originalMax - p.originalMin) * (x1 / WIDTH);
                        let max = p.originalMin + (p.originalMax - p.originalMin) * (x2 / WIDTH);
                        p.min = min;
                        p.max = max;
                        if (p.get(true) < min || p.get(true) > max) {
                            p.set(min + 0.1 * (max - min));
                        }

                        let d = p.depthParameter;
                        if (!d) {
                            continue;
                        }
                        let depthMin = d.originalMin + (d.originalMax - d.originalMin) * (y1 / HEIGHT);
                        let depthMax = d.originalMin + (d.originalMax - d.originalMin) * (y2 / HEIGHT);

                        d.min = depthMin;
                        d.max = depthMax;


                        if (d.get(true) < depthMin || d.get(true) > depthMax) {
                            p.depth = depthMin + 0.1 * (depthMax - depthMin);
                        }
                    }
                    setSelected([... selected]);
                    setSelection(undefined);
                    if (dragging) {
                        setDragging(undefined);
                    }
                    return;
                }

                let _selected = getParametersFromSelection(selection, effect, filteredParameters, macroToShow);
                if (isCommandDown()) {
                    setSelected([... selected, ..._selected]);
                } else {
                    setSelected(_selected);
                }
            } else if (!dragging) {
                setSelected([]);
            }
            setSelection(undefined);
        } 
        if (dragging) {
            setDragging(undefined);
        }
    }, [
        drawMode,
        macroToShow,
        setDensities,
        setSelectedDensity,
        isRegionMode,
        isDensitiesMode,
        setSelection,
        selection,
        selected,
        setSelected,
        setDragging,
        dragging,
        filteredParameters,
        selected
    ]);

    const startDragging = useCallback((e, parameter) => {
        e.preventDefault();
        if (drawMode) {
            return;
        }
        let now = new Date().getTime();
        if (!selected.includes(parameter)) {
            let group = effect.getGroupForParameter(parameter);
            if (parameter.planeMacro) {
                setSelected([parameter]);
            //} else if (group) {
             //   setSelected([... group._parameters]);
            } else {
                setSelected([parameter]);
            }
        }  else {
            if (now - lastClick.current <= DOUBLE_CLICK_TIME) {
                if (selected.length === 1) {
                    if (parameter.planeMacro) {
                        setSelected([parameter]);
                    } else {
                        let group = effect.getGroupForParameter(parameter);
                        setSelected(group ? [... group._parameters] : [parameter]);
                    }
                } else {
                    setSelected([parameter]);
                }
            }
        }
        lastClick.current = now;
        setDragging(getXY(e));
    }, [setDragging, selected, setSelected, drawMode]);

    useEffect(() => {
        if (window.isNFT) {
            window.addEventListener("mousemove", onMouseMove);
        }
        return () => {
            if (window.isNFT) {
                window.removeEventListener("mousemove", onMouseMove);
            }
        };
    }, [selection, setSelection, dragging, selected, setDragging, drawMode]);
    
    const onMouseMove = useCallback((e) => {
        let {x,y} = getXY(e);
        if (window.isNFT && !sequencerEngine.playing) {
            return;
        }
        if (window.isNFT && drawMode && !effect.pencilXParameter.get(true)) {
            effect.setPencil(x,y);
       }
        if (drawMode && effect.pencilXParameter.get(true) && effect.pencilYParameter.get(true)) {
            c++;
            if (window.isNFT) {
                let _c = c;
                setTimeout(() => {
                    if (_c === c) {
                        effect.setPencil(null, null);
                    }
                }, 1000);
            }
            let i = parseFloat;
            let x2= effect.pencilXParameter.get(true);
            let y2= effect.pencilYParameter.get(true);
            let d = dist({
                x1:x,
                y1:y,
                x2,
                y2
            });
            if (d > 12) {
                effect.setPencil(x,y);
            }
            return;
        }
        if (dragging) {
            let xDiff = x - dragging.x;
            let yDiff = y - dragging.y;
            const abs = Math.abs;
            if (abs(xDiff) <= MIN_DRAG && abs(yDiff) <= MIN_DRAG) {
                return;
            }
            let bulk = {};
            let dateA = new Date().getTime();
            for (let param of selected) {
                if (param.locked2D) {
                    continue;
                }
                if (param.isPlaneMacro) {
                    param.moveCoordinates(xDiff, yDiff);
                } else {
                    let {id, value} = param.moveCoordinates(xDiff, yDiff);
                    bulk[id] = value;
                }
            }
            let dateB = new Date().getTime();
            setEffectParameterValues(bulk);
            setDragging({x,y});
        } else {
            setSelection({
                ...selection,
                x2: x,
                y2: y
            });
        }
    }, [selection, setSelection, dragging, selected, setDragging, drawMode]);

    return {
        startDragging,
        onMouseDown,
        onMouseUp,
        onMouseMove,
        selection,
        selected,
        setSelected,
        setDrawMode,
        drawMode,
    };
};
